import type { ComponentProps, ReactNode } from 'react'
import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverCampaignSubtitle from './TriplePointTakeoverCampaignSubtitle'

interface Props {
  logo: ReactNode
  mobileCompactSubtitle?: boolean
  textColour?: App.Design.ContentColour
  titleVariant: ComponentProps<typeof Heading>['variant']
  viewOffersTo?: string
}

/**
 * The title, subtitle, and logo
 */
function TriplePointTakeoverCampaignHeader(props: Props) {
  const {
    logo,
    mobileCompactSubtitle,
    textColour: textColourOverride,
    titleVariant,
    viewOffersTo,
  } = props
  const [tier] = useCurrentLoyaltyTier()
  const textColour = textColourOverride ?? `tier-${tier}-contrast`
  const renderItalic = useCallback((chunks: ReactNode) => <i>{chunks}</i>, [])

  return <ProductPaletteProvider palette={`tier-${tier}`}>
    <Group direction="horizontal" gap={20} verticalAlign="center">
      {logo}
      <VerticalSpacer gap={2}>
        <Heading variant={titleVariant} colour={textColour}>
          <FormattedMessage
            id="IWJ9IQpEnsYW66vMerdJ"
            defaultMessage="Your next trip just got <i>3x</i> better"
            description="Hero carousel heading for triple points takeover in the site takeover promotion"
            values={{ i: renderItalic }}
          />
        </Heading>
        <TriplePointTakeoverCampaignSubtitle
          mobileCompact={mobileCompactSubtitle}
          textColour={textColour}
          viewOffersTo={viewOffersTo}
        />
      </VerticalSpacer>
    </Group>
  </ProductPaletteProvider>
}

export default TriplePointTakeoverCampaignHeader
